<template>
  <div id="contenedor-adjudicaciones-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :listaAdjudicaciones="getAdjudicacionesDirectas"
            :filtros="filtros"
            v-on:nuevaAdjudicacionDirecta="registrarNuevaAdjudicacionDirecta"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado
          :listadoAdjudicacionesDirectas="getListadoAdjudicacionesDirectas"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaAdjudicacionDirecta"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <registrar-nueva-adjudicacion-directa
        v-if="mostrarVentanaRegistrarNuevaAdjudicacionDirecta"
        v-on:cerrar="cerrarRegistrarNuevaAdjudicacionDirecta">
      </registrar-nueva-adjudicacion-directa>
    </v-dialog>
    <v-dialog
      v-if="estaAdjudicacionDirecta"
      v-model="mostrarVentanaEditarAdjudicacionDirecta"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <editar-adjudicacion-directa
        :adjudicacionDirectaEditar="estaAdjudicacionDirecta"
        v-on:cerrar="cerrarEditarAdjudicacionDirecta">
      </editar-adjudicacion-directa>
    </v-dialog>
    <v-dialog
      v-if="estaAdjudicacionDirecta"
      v-model="mostrarVentanaEliminarAdjudicacionDirecta"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-adjudicacion-directa
        :adjudicacionDirectaEliminar="estaAdjudicacionDirecta"
        v-on:cerrar="cerrarRemoverAdjudicacionDirecta">
      </eliminar-adjudicacion-directa>
    </v-dialog>
  </div>
</template>

<script>
import ADJUDICACIONES_DIRECTAS from '@/graphql/querys/administracion/adjudicaciones/adjudicacionesDirectas.gql';
import RegistrarNuevaAdjudicacionDirecta from '@/components/administracion/adjudicaciones/Nueva.vue';
import EditarAdjudicacionDirecta from '@/components/administracion/adjudicaciones/Editar.vue';
import EliminarAdjudicacionDirecta from '@/components/administracion/adjudicaciones/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import TituloToolBar from './TituloToolBar.vue';

export default {
  name: 'AdjudicacionesDefault',
  components: {
    TituloToolBar,
    RegistrarNuevaAdjudicacionDirecta,
    EditarAdjudicacionDirecta,
    EliminarAdjudicacionDirecta,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevaAdjudicacionDirecta: false,
      mostrarVentanaEditarAdjudicacionDirecta: false,
      mostrarVentanaEliminarAdjudicacionDirecta: false,
      estaAdjudicacionDirecta: null,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
        contratistas: [],
      },
    };
  },
  apollo: {
    adjudicacionesDirectas: {
      query: ADJUDICACIONES_DIRECTAS,
    },
  },
  mounted() {
    eventBus.$on('editar-adjudicacion-directa', (adjudicacionDirecta) => {
      this.estaAdjudicacionDirecta = adjudicacionDirecta;
      this.mostrarVentanaEditarAdjudicacionDirecta = true;
    });
    eventBus.$on('eliminar-adjudicacion-directa', (adjudicacionDirecta) => {
      this.estaAdjudicacionDirecta = adjudicacionDirecta;
      this.mostrarVentanaEliminarAdjudicacionDirecta = true;
    });
  },
  methods: {
    registrarNuevaAdjudicacionDirecta() {
      this.mostrarVentanaRegistrarNuevaAdjudicacionDirecta = true;
    },
    cerrarRegistrarNuevaAdjudicacionDirecta() {
      this.mostrarVentanaRegistrarNuevaAdjudicacionDirecta = false;
    },
    cerrarEditarAdjudicacionDirecta() {
      this.mostrarVentanaEditarAdjudicacionDirecta = false;
      this.estaAdjudicacionDirecta = null;
    },
    cerrarRemoverAdjudicacionDirecta() {
      this.mostrarVentanaEliminarAdjudicacionDirecta = false;
      this.estaAdjudicacionDirecta = null;
    },
  },
  computed: {
    getAdjudicacionesDirectas() {
      if (!this.adjudicacionesDirectas) return [];
      return this.adjudicacionesDirectas;
    },
    getListadoAdjudicacionesDirectas() {
      if (!this.adjudicacionesDirectas) return [];
      return this.adjudicacionesDirectas
        // Agregar Ejercicio
        .map((adjudicacion) => ({
          ...adjudicacion,
          ejercicio: new Date(adjudicacion.fecha).getFullYear(),
        }))
        .slice()
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
        // Filtrar por Ejercicio
        .filter(({ ejercicio }) => {
          if (typeof this.filtros.ejercicio === 'string') {
            const split = this.filtros.ejercicio.split('-');
            const ejer = Number(split[0]);

            return ejercicio === ejer;
          }

          return ejercicio === this.filtros.ejercicio;
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por Texto de Busqueda
        .filter((adjudicacion) => {
          if (!this.filtros.buscarTexto) return adjudicacion;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numeroContrato = this.$normalizacionTexto(adjudicacion.numeroContrato);
          const meta = this.$normalizacionTexto(adjudicacion.meta);
          const numeroDictamen = this.$normalizacionTexto(adjudicacion.numeroDictamen);
          const contratista = this.$normalizacionTexto(
            adjudicacion.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numeroContrato)
            || expt.test(meta)
            || expt.test(numeroDictamen)
            || expt.test(contratista)
            || expt.test(adjudicacion.numeroContrato)
            || expt.test(adjudicacion.meta)
            || expt.test(adjudicacion.numeroDictamen)
            || expt.test(adjudicacion.contratista.nombreRazonSocial)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
